import { Avatar, Stack, Typography } from '@mui/material';
import React from 'react'
import { StandardTableActions } from '../../../Components/StandardTableActions/StandardTableActions';
import { DataTable } from '../../../Components/Table/DataTable';
import { IDataTableProps, MobileLogoRenderType, RenderType } from '../../../Components/Table/interfaces/IDataTableProps';
import { useAppSelector, IStoreState, useAppDispatch } from '../../../redux';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import { CustomButton } from '../../../Components/CustomButton';
import { clearTaxInfoListSync, fetchTaxInfoListAsync } from '../../../redux/settings/tax-info';
import { useNavigate } from 'react-router-dom';
import { clearPaymentGatewayStateSync, fetchMultiplePaymentGatewayAsync, IPaymentGateway } from '../../../redux/settings';
import { appNabarRoutes } from '../../../router/AppNavbarRoutes';
import { useOutletContext } from '../../../providers';

export const PaymmentGatewayTable = () => {
    const { outlet_details: { outlet_uuid } } = useOutletContext()
    const {
        data: paymentGatewayList,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.settings.paymentGateway.payment_gateway_list);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();


    const [pagination, setPagination] = React.useState({
        pageNumber: 1,
        rowsPerPage: 10,
    });


    const dataTableProps: IDataTableProps = {
        isPagination: true,
        rowsPerPageOptions: 25,
        isDataLoading: false,
        mobileLogo: {
            type: MobileLogoRenderType.reactNode,
            onMobileLogoRender: (data: any) => {
                return (
                    <Avatar
                        sx={{
                            width: 45,
                            height: 45,
                            color: "#fff",
                            ml: "-8px",
                            mr: 2,
                        }}
                    ></Avatar>
                );
            },
        },
        columns: [
            {
                key: "view",
                headerName: "Actions",
                fieldName: "",
                headingAlign: "center",
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (value, row: IPaymentGateway) => {
                    return (
                        <StandardTableActions
                            onEditClick={() => navigate(`${appNabarRoutes.settings.paymentGateway}/edit/${row.payment_gateway_uuid}`)}
                        />
                    );
                },
            },
            {
                key: "payment_gateway",
                headerName: "Gateway Name",
                fieldName: "payment_gateway",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "website_base_url",
                headerName: "Website Url",
                fieldName: "website_base_url",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "payment_success_url",
                headerName: "Payment Success Url",
                fieldName: "payment_success_url",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },

            {
                key: "payment_failed_url",
                headerName: "Payment Faild Url",
                fieldName: "payment_failed_url",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "create_ts",
                headerName: "Created At",
                fieldName: "create_ts",
                enableSorting: true,
                renderType: RenderType.DATE_TIME,
            },
        ],

        items: paymentGatewayList,
        onPageChange: (newPageNumber: number) => {
            setPagination({ ...pagination, pageNumber: newPageNumber });
        },
        onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
            setPagination({
                pageNumber: pageNumber,
                rowsPerPage: rowsPerPage,
            });
        },
    };


    React.useEffect(() => {
        if(!outlet_uuid) return;
        dispatch(
            fetchMultiplePaymentGatewayAsync({
                outlet_uuid,
                page: pagination.pageNumber,
                rowsPerPage: pagination.rowsPerPage,
            }),
        );
    }, [pagination, outlet_uuid]);

    React.useEffect(() => {
        return () => {
            dispatch(clearPaymentGatewayStateSync());
        };
    }, []);



    return (
        <PageContainer title="Payment Gateway" description='inner page' >
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} p={2}>
                <Typography variant='h2' fontSize={18}>Payment Gateways</Typography>
                <CustomButton
                    variant="contained"
                    color="primary"
                    sx={{
                        display: "flex",
                        border: "1px solid"
                    }}
                    onClick={() => navigate(`${appNabarRoutes.settings.paymentGateway}/create`)}
                >
                    Add New Gateway
                </CustomButton>
            </Stack>
            <DataTable {...dataTableProps} />
        </PageContainer>
    );
}
